export class Auth {
    identifier: string;
    code: string;
}
